import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import { howlMapper } from 'config/constants/audio'
import { useState } from 'react'
import { DiceGameTargetType } from 'views/InhouseGame/Dice/config'
import { DiceBet } from 'views/InhouseGame/Dice/config/types'
import { useDiceAction, useDiceBetListener } from 'views/InhouseGame/Dice/hooks'
import DiceTargetAdjuster from './DiceTargetAdjuster'

const DiceGameResult: React.FC<
  {
    disabled: boolean
    target: string
    setTarget: (target: string) => void
    targetType: DiceGameTargetType
    volumeEnable: boolean
  } & BoxProps
> = ({ target, setTarget, targetType, volumeEnable, disabled, ...props }) => {
  const [currentBet, setCurrentBet] = useState<DiceBet>(null)
  const { finishBet } = useDiceAction()

  useDiceBetListener((bet: DiceBet) => {
    setCurrentBet(null)
    if (!bet) return
    setCurrentBet(bet)

    const isWinBet =
      bet.target.type === DiceGameTargetType.Over ? bet.result >= bet.target.value : bet.result <= bet.target.value

    if (bet.disabledDisplay) {
      if (isWinBet) {
        if (volumeEnable) howlMapper.DiceWin.play()
      }
    } else if (volumeEnable) howlMapper.DicePlaying.play()

    const timeout = setTimeout(
      () => {
        if (isWinBet && !bet.disabledDisplay) {
          if (volumeEnable) howlMapper.DiceWin.play()
        }
        finishBet()
      },
      bet.disabledDisplay ? 100 : 400,
    )

    return () => {
      clearTimeout(timeout)
    }
  })

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100%"
      overflow="hidden"
      height="100%"
      minHeight="180px"
      p={['12px', '', '20px']}
      {...props}
    >
      <DiceTargetAdjuster
        maxWidth="700px"
        value={target}
        setValue={!disabled ? setTarget : null}
        targetType={targetType}
        volumeEnable={volumeEnable}
        betResult={currentBet}
        disabledAnimation={currentBet?.disabledDisplay}
      />
    </Flex>
  )
}

export default DiceGameResult
